import React from "react";

type OnSVGProps = {
	className?: string;
	size?: number;
	fontSize?: number;
};

export const OnSVG = ({ className, size = 16, fontSize = 18 }: OnSVGProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<text
				x="50%"
				y="50%"
				dominantBaseline="middle"
				textAnchor="middle"
				fill="currentColor"
				fontFamily="Source Sans Pro, sans-serif"
				fontWeight="600"
				fontSize={fontSize}
				letterSpacing="0.5"
			>
				on
			</text>
		</svg>
	);
};

OnSVG.displayName = "OnSVG";
